import { Navigate, Outlet } from "react-router-dom";
import { hasValidAuthSession } from "../helpers/authSession";
import Constant from "../util/constant";

const STAFF_ROLES = new Set([
  Constant.ROLES.CLUB_MANAGER,
  Constant.ROLES.CLUB_EMPLOYEE,
]);

const ProtectedClubStaffRoute = () => {
  const role = window.localStorage.getItem("role");
  const allowed = hasValidAuthSession() && STAFF_ROLES.has(role);

  return allowed ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedClubStaffRoute;
